import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';
import { RootState } from '../store';

export type ToolSliceType = {
  loginTip: "tip_sign" | "login" | "forgot-password" | "register" | string;
  tiktokShopTip: {
    type: "tip_link" | "tip_loading" | "match_product" | "tip_copy" | "",
    otherParam: {[key: string]: any}
  }
  updateTime: string;
  msgTip: {
    content: string;
    bottom?: string;
    state?: "error"
  } | null
};

const initialState: ToolSliceType = {
  loginTip: "",
  updateTime: "",
  msgTip: null,
  tiktokShopTip: { type: "", otherParam: {} }
};

const slice = createSlice({
  name: 'Auth',
  initialState,
  reducers: {
    setTipLogin(state: ToolSliceType, action: PayloadAction<ToolSliceType["loginTip"]>) {
      state.loginTip = action.payload;
    },
    setUpdateTime(state: ToolSliceType, action: PayloadAction<string>) {
      state.updateTime = action.payload;
    },
    setTiktokShopTip(
      state: ToolSliceType,
      action: PayloadAction<ToolSliceType['tiktokShopTip']> 
    ){
      state.tiktokShopTip = action.payload;
    },
    setMsgTip(
      state: ToolSliceType,
      action: PayloadAction<{ content: string; bottom?: string; state?: "error" } | null>
    ) {
      state.msgTip = action.payload;
    }
  },
});

export const {
  setTipLogin, setUpdateTime, setTiktokShopTip, setMsgTip
} = slice.actions;

export const selectTool = createSelector(
  [(state: RootState) => state.tool],
  (state) => state
);

export default slice.reducer;